import { render } from "./ErrorBlock.vue?vue&type=template&id=aec6f71e&scoped=true"
import script from "./ErrorBlock.vue?vue&type=script&lang=js"
export * from "./ErrorBlock.vue?vue&type=script&lang=js"

import "./ErrorBlock.vue?vue&type=style&index=0&id=aec6f71e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec6f71e"]])

export default __exports__